import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { Filter } from "@/partner/shared/components/Filter";
import {
  ReportStatusType,
  ReportTypeType,
} from "@/types/graphql/partner.generated";

export const ReportsFilter: FC = () => {
  const { t } = useTranslation();

  return (
    <Filter
      title={t("reports.pageTitle")}
      selects={[
        {
          name: "type",
          label: t("reports.filter.typeLabel"),
          options: Object.values(ReportTypeType).map((value) => ({
            value,
            label: t(`reports.type.${value}`),
          })),
        },
        {
          name: "status",
          label: t("reports.filter.statusLabel"),
          options: Object.values(ReportStatusType).map((value) => ({
            value,
            label: t(`reports.status.${value.toLowerCase()}`),
          })),
        },
      ]}
      fields={{}}
    />
  );
};
